import React from "react";
import VipProgress from "../../../shared/components/VipProgress";

/**
 * Mobile-only VIP progress banner, tapped to open the VIP page. Module-scope
 * component (was inline in GameLobby's render body). The parent gates on
 * isMobile && isLoggedIn.
 */
const MobileVipBanner = ({ navigate }) => (
  <div className="mb-8">
    <div
      onClick={() => navigate("/vip")}
      className="cursor-pointer transition-transform duration-200 ease-out hover:scale-[1.01] active:scale-[0.98] motion-reduce:transform-none motion-reduce:transition-none"
    >
      <VipProgress className="border-2 border-transparent transition-colors duration-150 hover:border-primary/30" />
    </div>
  </div>
);

export default MobileVipBanner;
